export default {
    wizardType: "HUBSPOT",

    getConnectionParams: (type, model) => ({
        useConnectionProfile: model.get("useConnectionProfile"),
        connectionProfileName: model.get("connectionProfileName"),
        AuthMode: model.get("authMode"),
        AccessToken: model.get("accessToken"),
        PrivateAppToken: model.get("privateAppToken"),
        ClientId: model.get("clientId"),
        ClientSecret: model.get("clientSecret"),
        RefreshToken: model.get("refreshToken"),
    }),
};

